export default "__VITE_ASSET__CdFKvL$j__"